import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

export function initFlatpickr(selector, config = {}) {
	const fp = flatpickr(selector, {
		inline: config.isOpen ?? false,
		altInputClass: 'ebc-date-picker',
		mode: config.mode ?? 'range',
		minDate: config.minDate ?? 'today',
		locale: config.locale ?? 'en',
		altInput: true,
		altFormat: config.clientDateFormat ?? 'F j, Y',
		dateFormat: 'Y-m-d',
		...(config.set ?? null),
		onReady(_, __, instance) {
			const wrapperStyle = document
				.querySelector('#ebc-wrapper')
				?.getAttribute('style');
			if (wrapperStyle) {
				const currentStyle =
					instance.calendarContainer.getAttribute('style') || '';
				instance.calendarContainer.setAttribute(
					'style',
					`${currentStyle} ${wrapperStyle}`
				);
			}
			instance.calendarContainer.classList.add('ebc-date-picker');
		},
		onChange(selectedDates, dateStr, instance) {
			if (typeof config.onChange === 'function') {
				config.onChange(selectedDates, dateStr, instance);
			}
		},
	});
	return fp;
}
